import React from 'react'

const CompanyOverview = ({companyOverview}) => {
  return (
    <div className="w-full bg-white">
    <div className="container max-w-[1240px] mx-auto w-full h-[350px] flex flex-col">
      <h3 className="w-[182px] h-[27px] font-semibold text-[18px] text-black text-start">
        Company Overview
      </h3>
      <hr className="w-[228px] h-[3px] bg-[#FF6300] text-start mt-[8px]" />
      <div className="flex w-full h-[280px] flex-row items-start justify-between mt-[20px]">
        <div className="flex flex-col gap-y-[15px] h-full">
          <p className="w-[716px] h-[84px] text-start text-black font-medium text-[16px] leading-[25px]">
            {companyOverview}
          </p>
          {/* <p className="w-[716px] h-[56px] text-start text-black font-medium text-[16px] leading-[25px]">
            The header quarter is located in Mumbai and two other branches
            located in Delhi (DL) and Punjab (PB).
          </p>
          <p className="w-[716px] h-[84px] text-start text-black font-medium text-[16px] leading-[25px]">
            The company aims to grow in the market, open more stores in
            strategic locations and create its online store presence so that
            it can increase its customers across the united states
          </p> */}
        </div>

        <img
          src={require("../../assets/WebFront/Overview/image 263.png")}
          alt=""
          className="w-[395px] h-[247px]"
        />
      </div>
    </div>
  </div>
  )
}

export default CompanyOverview